import type { CartDonationData } from '../../Header/types'
import {
  Text,
  Image,
  FadeInOut,
  TransitionController,
  useToasts,
  useMediaQuery,
} from '@lounge-fe/ui-kit'
import { SelectAmount } from './SelectAmount'
import { useTranslation } from 'react-i18next'

export const CartDonation: React.FC<CartDonationData> = ({
  confirmation_message,
  left_background_color,
  logo,
  product,
  right_background_color,
  title,
}) => {
  if (!product) {
    return null
  }

  const { toast } = useToasts()
  const { t } = useTranslation()
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.sm})`)

  const handleError = () =>
    toast({
      severity: 'critical',
      title: t('general.error'),
      message: t('general.error_unexpected'),
      direction: isDesktop ? 'left' : 'top',
    })

  return (
    <div className="flex flex-row">
      <div
        className="basis-2/3 max-h-[92px] min-h-[92px] px-4 py-3 2xl:py-6 2xl:px-10 flex flex-col gap-y-1 justify-center"
        style={{
          backgroundColor: left_background_color,
        }}
      >
        <TransitionController>
          <FadeInOut>
            <FadeInOut.Initial className="flex flex-col gap-y-2">
              <Text className="font-display" variant="title-five">
                {title}
              </Text>

              <TransitionController.Trigger>
                {(handleTransition) => (
                  <SelectAmount
                    product={product}
                    onSelect={handleTransition}
                    onError={handleError}
                  />
                )}
              </TransitionController.Trigger>
            </FadeInOut.Initial>
            <FadeInOut.Animate className="h-full">
              <Text
                className="flex justify-center items-center align-middle font-display h-full"
                variant="title-five"
              >
                {confirmation_message}
              </Text>
            </FadeInOut.Animate>
          </FadeInOut>
        </TransitionController>
      </div>
      <div
        className="basis-1/3 flex justify-center items-center p-5"
        style={{
          backgroundColor: right_background_color,
        }}
      >
        {logo && <Image src={logo.src} alt={logo.alt} />}
      </div>
    </div>
  )
}
